/* list.tsx generated by @compiled/babel-plugin v0.36.1 */
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
import { forwardRef } from 'react';
function _List(_ref, forwardedRef) {
  var children = _ref.children,
    xcss = _ref.xcss;
  return (
    /*#__PURE__*/
    /**
     * We are using `role="list"` instead of a `ul` element to enable more flexible
     * composition. By using ARIA roles we can validly have elements between a list
     * and list items, as long as those in-between elements have no semantics.
     */
    React.createElement("div", {
      role: "list",
      ref: forwardedRef,
      className: xcss
    }, children)
  );
}

/**
 * __List__
 *
 * A an element with the role of `list` for semantically grouping list items.
 *
 * This is the internal primitive used by other external components in the navigation system.
 */
export var List = /*#__PURE__*/forwardRef(_List);